import {createSelector,} from "@reduxjs/toolkit";
import {dayJS} from "./applicationConf";
import {TAB_ENUM_INDIVIDUI_TARGET, TABS_CHOOSEN} from "./costanti";
import {isRitirato, isDocenteFuoriIncarico} from "./fanctionUtility";
import _ from "lodash";


export const checkIfRenderCmpSelector = createSelector(
    [state => state.corso.corso, state => state.docenti.docenti, state => state.individui.individui],
    (corso, docenti, individui) => corso.allievi.length === individui.length && corso.docenti.length === docenti.length
);
export const checkErrors = createSelector(
    [state => state.datiRegistro.error, state => state.validazione.error],
    (datiRegistroError, datiValidazioneError) => datiRegistroError.length > 0 || datiValidazioneError.length > 0
);

export const mapMesiValidati = createSelector(
    [state => state.validazione.mesiValidati],
    (mesiValidati) =>
        mesiValidati.reduce((acc, mesiValidatiInd) =>
                acc.set(mesiValidatiInd.idAnagrafica,
                    mesiValidatiInd.mesiValidati.map(objMeseValidato => ({
                        yearMonth: objMeseValidato.mese,
                        description: dayJS(objMeseValidato.mese, 'YYYY-MM').format('YYYY - MMMM')
                    }))
                )
            , new Map())
);

// only for Registry section
export const individualsParticipating = (tab, data) => createSelector(
    [
        state => state.corso.corso,
        state => state.individui.individui,
        state => state.docenti.docenti,
    ],
    (corso, individui, docenti) =>
        tab === TABS_CHOOSEN.ALLIEVI ?
            individui.filter(i => !isRitirato(corso, i.idAnagrafica, data)) :
            docenti.filter(d => !isDocenteFuoriIncarico(corso, d.idAnagrafica, data))
);

const selectCorso = state => state.corso.corso;
const selectParticipants = state => state.corso.participantsToTheDate;
const selectIndividui = state => state.individui.individui;
const selectDocenti = state => state.docenti.docenti;

export const individualsTarget = (tab) =>
    createSelector(
        [selectCorso, selectIndividui, selectDocenti],
        (corso, individui, docenti) =>
            tab === TABS_CHOOSEN.ALLIEVI ? individui : docenti
    );

export const individualsParticipants = (tab) =>
    createSelector(
        [selectCorso, selectParticipants, selectIndividui, selectDocenti],
        (corso, participants, individui, docenti) => {
            let ind;
            if (tab === TABS_CHOOSEN.ALLIEVI) {
                ind = individui.filter(i => participants.map(p => p.idAnagrafica).includes(i.idAnagrafica))
            } else {
                ind = docenti.filter(d => !isDocenteFuoriIncarico(corso, d.idAnagrafica, dayJS().format('YYYY-MM')));
            }
            return _.sortBy(ind, ['cognome', 'nome']);
        });

export const checkLoadingTimbrature = (tab) =>
    createSelector(
        [
            state => state.corso,
            state => state.timbrature.timbrature,
            state => state.timbrature.error
        ],
        ({corso, isError}, timbrature, error) => {
            return !dayJS().isBefore(corso.dataInizio, 'day') && (
                !isError &&
                ((corso[TAB_ENUM_INDIVIDUI_TARGET[tab].propCorso].length > 0 && (timbrature.length + error.length) === 0)
                ))
        });

export const reloadDataRegistri = createSelector(
    [
        state => state.timbrature.timbratureManualiEnd,
        state => state.validazione.svalidazioneEnd,
        state => state.giustificativi.giustificativiEnd
    ],
    (timbraturaManualiEnd, svalidazioneEnd, giustificativiEnd) => timbraturaManualiEnd || svalidazioneEnd || giustificativiEnd
)

